import React from "react";
import uf from "usefuljs";
import { useEffectOnce } from "react-use";

import { Table } from "@fluentui/react-northstar";
import { APIRes } from "@interfaces/api";
import {FbAcc} from "@interfaces/acc";
import styles from "./table.module.scss";

type AccTableProps = {
    onClickUser:(user_acc:FbAcc)=>void
}

interface TableDataRow {
    key:number,
    items: TableDataContent[],
    onClick: (user_acc:string)=>void
}

interface TableDataContent {
    content: null | string | number,
    key: string
}

const AccTable = (props:AccTableProps)=>{
    const [rows,setRows] = React.useState<TableDataRow[]>([]);
    const header = {
        key:"header",
        items:[
            {
                content: "UID",
                key: "uid"
            },
            {
                content: "Account",
                key: "fb_acc"
            },
            {
                content: "Has Cookie",
                key:"has_cookie"
            },
            {
                content: "Endpoint",
                key: "endpoint"
            },
        ]
    }

    const updateTable = async()=>{
        const data = await uf.ajax<APIRes<FbAcc[]>>({
            url:"https://jennysss.lenx.ai/fbm/api/acc/list"
        }).catch(err=>{throw err})
        if(data.result === "success"){
            setRows(data.data!.map((d,i) => ({
                key:i,
                items: [
                    { content: d.uid , key: uf.shortuid()},
                    { content: d.fb_acc , key: uf.shortuid()},
                    { content: !!d.cookie ? "True" : "False", key:uf.shortuid() },
                    {content: d.endpoint, key: uf.shortuid()}
                ],
                onClick: ()=>{ 
                    props.onClickUser(d);
                }
            })))
        }
    }

    useEffectOnce(()=>{
        const itv = setInterval(()=>{
            updateTable();
        },30000);
        updateTable();
        return ()=>{
            clearInterval(itv);
        }
    })
    return (
        <div id={styles.table}>
            <Table
                rows={rows}
                header={header}
            />
        </div>
    )
}

export default AccTable;
